import { normalizeIso8601Date } from '@libs/dateTime';
export { DOMAIN_NAME } from '../common';

const TIMESHEET_ROUTE = 8;
const ROWS_PER_PAGE = 7;
const CREATE_ATTENDANCE_ROUTE = 28;

const ADMIN_TIMESHEET_INTITAL_API_PARAMS = {
    date: normalizeIso8601Date(),
    pageSize: 10,
    filters: {
        branch: null,
        status: null
    }
};

const timesheetSummaryDefaultValue = {
    'present': 0,
    'arrivedLate': 0,
    'casualLeave': 0,
    'sickLeave': 0,
    'maternityPaternityLeave': 0,
    'compensatoryLeave': 0,
    'otherLeave': 0,
    'holiday': 0,
    'remote': 0
};

const timesheetSummaryHeaders = {
    'workingDays': "Working Days",
    'totalPresent': "Total Present",
    'present': "On site",
    'remote': "Remote",
    'arrivedLate': "Late",
    'casualLeave': "CL",
    'sickLeave': "SL",
    'maternityPaternityLeave': "ML/PL",
    'compensatoryLeave': "CMPL",
    'otherLeave': "Other",
    'holiday': "Holiday",
};

/** Full names shown as tooltips on the (abbreviated) column headers. */
const timesheetSummaryHeaderFullNames = {
    'present': 'Worked on site',
    'remote': 'Worked remotely',
    'arrivedLate': 'Arrived late',
    'totalPresent': 'On site + Remote + Late',
    'casualLeave': 'Casual Leave',
    'sickLeave': 'Sick Leave',
    'maternityPaternityLeave': 'Maternity / Paternity Leave',
    'compensatoryLeave': 'Compensatory Leave',
    'otherLeave': 'Other Leave',
    'holiday': 'Holiday',
    'workingDays': 'All days except the calendar’s holidays & weekends',
};

export {
    TIMESHEET_ROUTE,
    ROWS_PER_PAGE,
    CREATE_ATTENDANCE_ROUTE,
    ADMIN_TIMESHEET_INTITAL_API_PARAMS,
    timesheetSummaryDefaultValue,
    timesheetSummaryHeaders,
    timesheetSummaryHeaderFullNames
};
